import React from "react";
import { Document, Page, Text, View, Image, StyleSheet, Font } from "@react-pdf/renderer"
import QRCode from "qrcode"

Font.register({
	family: 'Northlane Two',
    src: '/fonts/Northlane/Northlane-Two.ttf',
    fontWeight: 'normal',
});

export default function Ticket({ticket}){

	const formatearFecha = (fechaISO) => {
		const fecha = new Date(fechaISO)
		const dia = fecha.getDate().toString().padStart(2, '0')
		const mes = (fecha.getMonth() + 1).toString().padStart(2, '0')
		const anio = fecha.getFullYear()
		return `${dia}/${mes}/${anio}`
	};

	const qrValue = ticket?.identifier
    const [qrImage, setQrImage] = React.useState(null)

    React.useEffect(() => {
        QRCode.toDataURL(qrValue)
            .then((url) => {
                setQrImage(url)
            })
            .catch((err) => {
                console.log(err)
            });
    }, [qrValue])

	const styles = StyleSheet.create({
		pagina: {
			flexDirection: 'column',
			padding: 0,
		},
		detallesEntrada: {
			border: '1px solid #000',
			marginBottom: 0,
			padding: 1,
		},
		tituloDetalles: {
			fontSize: 13,
			fontFamily: 'Northlane Two',
			textAlign: 'center',
			marginBottom: 0,
		},
		tablaDetalles: {
			border: '1px solid #000',
		},
		fila: {
			flexDirection: 'row',
			borderBottom: '1px solid #000',
			height: 16,
		},
		celda: {
			flex: 1,
			fontSize: 8,
			padding: 0,
			borderRight: '1px solid #000',
		},
		inferior: {
			flexDirection: 'row',
			alignItems: 'flex-start',
			justifyContent: 'space-between',
			marginTop: 0,
		},
		logosNombres: {
			flexDirection: 'row',
			flex: 3,
			alignItems: 'flex-start',
			justifyContent: 'space-around',
		},
		club: {
			alignItems: 'center',
			flex: 1,
		},
		logo: {
			width: 45,
			height: 45,
			marginBottom: 0,
		},
		nombreClub: {
			fontSize: 7,
			textAlign: 'center',
			backgroundColor: '#eee',
			padding: 0,
			marginTop: 0,
		},
		vs: {
			flex: 1,
			alignItems: 'center',
			justifyContent: 'flex-start',
		},
		textoVS: {
			fontSize: 11,
			fontWeight: 'bold',
		},
		qrContainer: {
			flex: 1,
			alignItems: 'center',
			justifyContent: 'flex-start',
		},
		qr: {
			width: 60,
			height: 60,
		},
	})

	const orientation = ticket?.match?.ticketOrientation
	const widthTicket = 670;
	const heightTicket = 120;
	const template = ticket?.match?.ticketOrientation ? '/images/templateTicketHorizontal.png' : '/images/templateTicketVertical.png'

	const matchTemplate = ticket?.match?.template ? `${ticket?.match?.template}?v=1` : undefined
	const hostBadge = ticket?.match?.hostBadge  ? `${ticket?.match?.hostBadge}?v=1` : undefined
	const visitorBadge = ticket?.match?.visitorBadge ? `${ticket?.match?.visitorBadge}?v=1` : undefined
	const thumbnail = ticket?.match?.thumbnail ? `${ticket?.match?.thumbnail}?v=1` : undefined

	return (
		<Document>
            <Page size={{width: widthTicket, height: heightTicket}} style={styles.pagina}>
				{/* Sección superior: Detalles de la entrada */}
				<View style={styles.detallesEntrada}>
					<Text style={styles.tituloDetalles}>DETALLES DE LA ENTRADA</Text>
					<View style={styles.tablaDetalles}>
						<View style={styles.fila}>
							<Text style={styles.celda}>SECTOR: {ticket?.sector?.name}</Text>
							<Text style={styles.celda}>TIPO: {ticket?.fee?.name}</Text>
							<Text style={styles.celda}>ASIENTO: {ticket?.seat || ""}</Text>
						</View>
						<View style={styles.fila}>
							<Text style={styles.celda}>FECHA: {formatearFecha(ticket?.match?.date)}</Text>
							<Text style={styles.celda}>HORA: {ticket?.match?.hour}</Text>
							<Text style={styles.celda}>PRECIO: {ticket?.price} €</Text>
						</View>
					</View>
				</View>

				{/* Sección inferior: Logos, nombres y QR */}
				<View style={styles.inferior}>
					{/* Logos y nombres */}
					<View style={styles.logosNombres}>
						{/* Club 1 */}
						<View style={styles.club}>
							<Image style={styles.logo} src={hostBadge} />
							<Text style={styles.nombreClub}>{ticket?.match?.host}</Text>
						</View>
						{/* VS */}
						<View style={styles.vs}>
							<Text style={styles.textoVS}>VS</Text>
						</View>
						{/* Club 2 */}
						<View style={styles.club}>
							<Image style={styles.logo} src={visitorBadge} />
							<Text style={styles.nombreClub}>{ticket?.match?.visitor}</Text>
						</View>
					</View>
					{/* QR */}
					<View style={styles.qrContainer}>
						{qrImage && <Image style={styles.qr} src={qrImage} />}
					</View>
				</View>
            </Page>
		</Document>
	)
}